export const disponibilitesColumnsValues: {
  dayName: string;
  week: number;
  firstLabel: string;
  firstValue: string;
  secondLabel: string;
  secondValue: string;
  thirdLabel: string;
  thirdValue: string;
  fourthLabel: string;
  fourthValue: string;
  fifthLabel: string;
  fifthValue: string;
}[] = [
    {
      dayName: "Lundi",
      week: 1,
      firstLabel: "1 Juin",
      firstValue: "2026-06-01",
      secondLabel: "8 Juin",
      secondValue: "2026-06-08",
      thirdLabel: "15 Juin",
      thirdValue: "2026-06-15",
      fourthLabel: "22 Juin",
      fourthValue: "2026-06-22",
      fifthLabel: "29 Juin",
      fifthValue: "2026-06-29",
    },
    {
      dayName: "Mardi",
      week: 1,
      firstLabel: "2 Juin",
      firstValue: "2026-06-02",
      secondLabel: "9 Juin",
      secondValue: "2026-06-09",
      thirdLabel: "16 Juin",
      thirdValue: "2026-06-16",
      fourthLabel: "23 Juin",
      fourthValue: "2026-06-23",
      fifthLabel: "30 Juin",
      fifthValue: "2026-06-30",
    },
    {
      dayName: "Mercredi",
      week: 1,
      firstLabel: "3 Juin",
      firstValue: "2026-06-03",
      secondLabel: "10 Juin",
      secondValue: "2026-06-10",
      thirdLabel: "17 Juin",
      thirdValue: "2026-06-17",
      fourthLabel: "24 Juin",
      fourthValue: "2026-06-24",
      fifthLabel: "1 Juillet",
      fifthValue: "2026-07-01",
    },
    {
      dayName: "Jeudi",
      week: 1,
      firstLabel: "4 Juin",
      firstValue: "2026-06-04",
      secondLabel: "11 Juin",
      secondValue: "2026-06-11",
      thirdLabel: "18 Juin",
      thirdValue: "2026-06-18",
      fourthLabel: "25 Juin",
      fourthValue: "2026-06-25",
      fifthLabel: "2 Juillet",
      fifthValue: "2026-07-02",
    },
    {
      dayName: "Vendredi",
      week: 1,
      firstLabel: "5 Juin",
      firstValue: "2026-06-05",
      secondLabel: "12 Juin",
      secondValue: "2026-06-12",
      thirdLabel: "19 Juin",
      thirdValue: "2026-06-19",
      fourthLabel: "26 Juin",
      fourthValue: "2026-06-26",
      fifthLabel: "3 Juillet",
      fifthValue: "2026-07-03",
    },
    {
      dayName: "Lundi",
      week: 2,
      firstLabel: "8 Juin",
      firstValue: "2026-06-08",
      secondLabel: "15 Juin",
      secondValue: "2026-06-15",
      thirdLabel: "22 Juin",
      thirdValue: "2026-06-22",
      fourthLabel: "29 Juin",
      fourthValue: "2026-06-29",
      fifthLabel: "6 Juillet",
      fifthValue: "2026-07-06",
    },
    {
      dayName: "Mardi",
      week: 2,
      firstLabel: "9 Juin",
      firstValue: "2026-06-09",
      secondLabel: "16 Juin",
      secondValue: "2026-06-16",
      thirdLabel: "23 Juin",
      thirdValue: "2026-06-23",
      fourthLabel: "30 Juin",
      fourthValue: "2026-06-30",
      fifthLabel: "7 Juillet",
      fifthValue: "2026-07-07",
    },
    {
      dayName: "Mercredi",
      week: 2,
      firstLabel: "10 Juin",
      firstValue: "2026-06-10",
      secondLabel: "17 Juin",
      secondValue: "2026-06-17",
      thirdLabel: "24 Juin",
      thirdValue: "2026-06-24",
      fourthLabel: "1 Juillet",
      fourthValue: "2026-07-01",
      fifthLabel: "8 Juillet",
      fifthValue: "2026-07-08",
    },
    {
      dayName: "Jeudi",
      week: 2,
      firstLabel: "11 Juin",
      firstValue: "2026-06-11",
      secondLabel: "18 Juin",
      secondValue: "2026-06-18",
      thirdLabel: "25 Juin",
      thirdValue: "2026-06-25",
      fourthLabel: "2 Juillet",
      fourthValue: "2026-07-02",
      fifthLabel: "9 Juillet",
      fifthValue: "2026-07-09",
    },
    {
      dayName: "Vendredi",
      week: 2,
      firstLabel: "12 Juin",
      firstValue: "2026-06-12",
      secondLabel: "19 Juin",
      secondValue: "2026-06-19",
      thirdLabel: "26 Juin",
      thirdValue: "2026-06-26",
      fourthLabel: "3 Juillet",
      fourthValue: "2026-07-03",
      fifthLabel: "10 Juillet",
      fifthValue: "2026-07-10",
    },
  ];
